// store.js
import { configureStore } from "@reduxjs/toolkit";
import dashboardReducer from "./features/dashboardSlice";
import blogsReducer from "./features/blogsSlice"; // Import blogs reducer
import aboutOverviewSlice from "./features/aboutOverviewSlice";
import aboutHistorySlice from "./features/aboutHistorySlice";
import ourServicesSlice from "./features/ourServicesSlice";
import investerServicesSlice from "./features/investerServicesSlice";
import developerServiceSlice from "./features/developerServiceSlice";
import otherServiceSlice from "./features/otherServiceSlice";
import ourPeopleSlice from "./features/ourPeopleSlice";
import jobSlice from "./features/jobSlice";
import clientsSlice from "./features/clientsSlice";
import projectSlice from "./features/projectSlice";
import fetchClientPage from "./features/clinetPageSlice";
import socialResponsibilitySlice from "./features/socialResponsibilitySlice";
const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    blogs: blogsReducer, // Add blogs reducer
    aboutOverview: aboutOverviewSlice,
    aboutHistory: aboutHistorySlice,
    ourServices: ourServicesSlice,
    investerServices: investerServicesSlice,
    developerServices: developerServiceSlice,
    otherService: otherServiceSlice,
    ourPeopleData: ourPeopleSlice,
    jobData: jobSlice,
    clients: clientsSlice,
    projects: projectSlice,
    clientPage: fetchClientPage,
    socialResponsibility: socialResponsibilitySlice,
  },
});

export default store;
